import styled from 'styled-components';

interface UnstyledButtonProps {
  visibility?: string;
}

const UnstyledButton = styled.button.attrs(({ type = 'button' }) => ({
  type,
}))<UnstyledButtonProps>`
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
  padding: 0;
  margin: 0;
  visibility: ${(props) => (props.visibility ? props.visibility : 'visible')};

  &:disabled {
    opacity: 1;
  }
`;

export default UnstyledButton;
